import React from 'react';
import { TextField } from '@mui/material';

interface CallDateFieldProps {
  value: string;
  onChange: (value: string) => void;
}

export const CallDateField: React.FC<CallDateFieldProps> = ({ value, onChange }) => {
  return (
    <TextField
      label="Call Date & Time"
      type="datetime-local"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      size="small"
      required
      fullWidth
      InputLabelProps={{
        shrink: true
      }}
    />
  );
};
